import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Locations from './pages/Locations';
import Contact from './pages/Contact';
import Packages from './pages/Packages';
import Booking from './pages/Booking';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import SofiaMladost from './pages/SofiaMladost';
import SofiaNSA from './pages/SofiaNSA';
import Plovdiv from './pages/Plovdiv';
import SofiaBoyana from './pages/SofiaBoyana';
import Kranevo from './pages/Kranevo';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function ProtectedAdminRoute({ children }) {
  const isAuthenticated = sessionStorage.getItem('adminAuthenticated') === 'true';
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/sofia-mladost" element={<SofiaMladost />} />
        <Route path="/locations/sofia-nsa" element={<SofiaNSA />} />
        <Route path="/locations/plovdiv" element={<Plovdiv />} />
        <Route path="/locations/sofia-boyana" element={<SofiaBoyana />} />
        <Route path="/locations/kranevo" element={<Kranevo />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Booking />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
